<template>
    <div>
        <div class="row no-gutters">
            <div class="col-12">
                <h2 class="order-summary__head">
                    {{ getTranslation('licence-configurator', 'product_name_subscription_customization', {'name': product.name }) }}
                </h2>
            </div>
        </div>

        <div class="custom-table">
            <div class="row custom-table__head d-none d-sm-flex">
                <div class="col-6"><div class="custom-table__head--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'quantity') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'price') }}</div></div>
                <div class="col-2"><div class="custom-table__head--elem text-sm-right">{{ getTranslation('front', 'total') }}</div></div>
            </div>
            <div class="row no-gutters custom-table__body">
                <template v-for="program in sortedPrograms()">
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('product-list-vue', 'program') }}</div></div>
                    <div class="col-8 col-sm-6">
                        <div class="custom-table__body--elem" v-html="programName(program)"></div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'quantity') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ quantity(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'price') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ linePrice(program) }}</div>
                    </div>
                    <div class="col-4 custom-table__title d-sm-none"><div class="custom-table__title--elem">{{ getTranslation('front', 'total') }}</div></div>
                    <div class="col-8 col-sm-2 text-sm-right">
                        <div class="custom-table__body--elem">{{ totalPrice(program) }}</div>
                    </div>
                    <div class="col-12 d-sm-none custom-table__separator"></div>
                </template>
            </div>
        </div>
        <br><br>
    </div>

</template>

<script>
    export default {
        methods: {
            sortedPrograms() {
                let self = this;
                let filtered = _.filter(this.$store.state.cart.leaseProlongConfigs, function(l) { return (l.product === self.product.id); });
                if (_.isEmpty(filtered)) {
                    return false;
                }
                return _.orderBy(filtered, ['daysDiff', 'sort_order'], ['desc', 'desc']);
            },
            quantity(program) {
                return program.quantity;
            },
            linePrice(item) {
                return this.priceFormat(this.getProgramPrice(item.program_id, '', this.licenceType, item.product, 1, false, item.discount, item.daysDiff));
            },
            totalPrice(item) {
                return this.priceFormat(this.getProgramPrice(item.program_id, '', this.licenceType, item.product, item.quantity, false, item.discount, item.daysDiff));
            },
            programName(item) {
                let name = '';
                if (item.quantity > 1) {
                    name = item.quantity + 'x' + ' ';
                }
                name += this.getProgramName(item.program_id, this.product.id);
                name += " ";
                name += item.lease_end;
                name += " " + this.shopConfigOptions.upgradeIcon + " ";
                name += item.lease_end_new;
                name +=  " ( " + this.getPluralTranslation('order-content', 'days_with_plural', item.daysDiff) +" ) "

                return name;
            }
        },
        computed: {

        },
        data() {
            return {
                programs: [],
                licenceType: this.getQtyName('lease', 'cloud'),
                shopConfigOptions: window.shopConfigOptions
            };
        },
        props: {
            product: Object,
        }
    }
</script>
